import { Model } from 'json-api-models';

import type { Models, Schemas } from '../models.ts';

export class CollectionProgress extends Model<Schemas['collectionProgress'], Models> {}
